import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/about/sections/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/about/sections/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/about/sections/Services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/providers/CompanyProvider.tsx");
